// Publish-time listing suggestion - GET /v1/marketplace/listings/suggest.
// One-shot helper that pre-fills the publish wizard's description /
// kind / cadence fields for a signal.
const action = "MARKETPLACE_LISTING_SUGGESTION";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
